import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import AboutStory from "./components/AboutStory";
import MissionVision from "./components/MissionVision";
import AboutTeam from "./components/AboutTeam";
import AboutCTA from "./components/AboutCTA";

export default function AboutPage() {
  return (
    <main>
      <Helmet>
        <title>About Us | Africa Investment Portal</title>
        <meta name="description" content="Learn about Africa Investment Portal — our mission to simplify company registration, investment facilitation, and market entry across East Africa for foreign and local investors." />
        <meta name="keywords" content="about Africa Investment Portal, AIP mission, investment facilitation East Africa, market entry Africa, foreign investors East Africa, local investors Africa" />
        <link rel="canonical" href="https://africainvestmentportal.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="About Africa Investment Portal" />
        <meta property="og:description" content="Learn about Africa Investment Portal — our mission to simplify company registration, investment facilitation, and market entry across East Africa." />
        <meta property="og:url" content="https://africainvestmentportal.com/about" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Africa Investment Portal" />
        <meta name="twitter:description" content="Learn about Africa Investment Portal — our mission to simplify company registration and investment facilitation across East Africa." />
      </Helmet>
      <Navbar />
      <AboutHero />
      <AboutStory />
      <MissionVision />
      <AboutTeam />
      <AboutCTA />
      <Footer />
    </main>
  );
}
